import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DesignAngularKitModule } from 'design-angular-kit';

@Component({
  selector: 'app-insert-discharge-date-modal',
  standalone: true,
  imports: [CommonModule, DesignAngularKitModule, FormsModule],
  templateUrl: './insert-discharge-date-modal.component.html',
  styleUrl: './insert-discharge-date-modal.component.scss',
})
export class InsertDischargeDateModalComponent {
  @Output() cancelled = new EventEmitter<void>();
  @Output() requestConfirmed = new EventEmitter<{ dischargeDate: Date | null, dischargeTime: string | null, note: string | null }>();

  dischargeDate: Date | null = null;
  dischargeTime: string | null = null;
  note: string = '';

  cancel(): void {
    this.cancelled.emit();
  }
  confirm() {
    this.requestConfirmed.emit({dischargeDate: this.dischargeDate, dischargeTime: this.dischargeTime, note: this.note});
  }
}
